import { Box, Container, Typography, Paper, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from "../../ThemeContext";
import TurnTimeSetter from "../organisms/TurnTimeSetter";
import UIAlertManager from "../organisms/UIAlertManager";

interface UIManagementParams {
}

const UIManagement = ({
}: UIManagementParams) => {
    const navigate = useNavigate();
    const { mode, toggleColorMode } = useTheme();

    return (
        <Container maxWidth="lg" sx={{ py: 4, minHeight: '100vh', position: 'relative' }}>
            {/* Theme Toggle Button */}
            <IconButton
                sx={{ position: 'absolute', top: 16, right: 16 }}
                onClick={toggleColorMode}
                color="inherit"
            >
                {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>

            {/* Back Button */}
            <Box sx={{ mb: 4 }}>
                <IconButton onClick={() => navigate('/returns')} color="primary">
                    <ArrowBackIcon />
                </IconButton>
            </Box>

            {/* Logo Section */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                <Box
                    component="img"
                    sx={{
                        height: 80,
                        maxWidth: 300,
                    }}
                    alt="Halcyon Still Water"
                    src={mode === 'dark' ? "/logo-white.png" : "/logo.png"}
                />
            </Box>

            {/* Title Section */}
            <Box sx={{ mb: 4, textAlign: 'center' }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
                    UI Management
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Configure turn times and UI alerts
                </Typography>
            </Box>

            {/* Turn Time Setter Section */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 500, mb: 3 }}>
                    Turn Times
                </Typography>
                <TurnTimeSetter />
            </Paper>

            {/* UI Alert Manager Section */}
            <Paper sx={{ p: 4 }}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 500, mb: 3 }}>
                    UI Alert
                </Typography>
                <UIAlertManager />
            </Paper>
        </Container>
    );
};

export default UIManagement;
